module.exports = __webpack_public_path__ + "img/tai-cau-truc.c4659c53.png";